import { EventEmitter } from 'events';
import dispatcher from '../dispatcher/dispatcher';


/**
 * used for the process stuff - create delete when the sharepoint sites been created
 * this has been changed now
 * @todo maybe delete at some pooint
 */
class ProcessStore extends EventEmitter {
    constructor() {
        super();
        this.errors = {};
        this.creates = {};
        this.userTables = {};
    }
    setProcess(processObj) {
        this.errors = {};
        this.creates = {};
        this.userTables = {};
        if (processObj === undefined) {
            return;
        } else {
            processObj[0].forEach((entry) => {
                this.userTables[entry.id] = entry;
            });
            processObj[1].forEach((error) => {
                let keys = Object.keys(error);
                this.errors[keys] = error[keys];
            });
            processObj[2].forEach((create) => {
                let keys = Object.keys(create);
                this.creates[keys] = create[keys];
            });
            this.emit("Creation-Changes");
        }
    }
    actionHandler(action) {
        switch (action.type) {
            case 'SET_PROCESS': {
                this.setProcess(action.object);
                break;
            }
            default: {
                break;
            }
        }
    }
}

const processStore = new ProcessStore();
dispatcher.register(processStore.actionHandler.bind(processStore));

export default processStore;


// WEBPACK FOOTER //
// ./src/store/processStore.js